export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/brand-pics-bg-da61e3d72c98474771fb08e660249c39.png";